import type { NiceModalHandler } from '@ebay/nice-modal-react';

/**
 * Bridge for DS Modal.Root — maps nice-modal handler to { open, onOpenChange }.
 * Usage: <Modal.Root {...wealthlaneModal(modal)}>
 */
export function wealthlaneModal(modal: NiceModalHandler) {
  return {
    open: modal.visible,
    onOpenChange: (open: boolean) => {
      if (!open) void modal.hide();
    },
  };
}

/**
 * Bridge for DS AlertDialog.Root — resolves false on dismiss.
 * Usage: <AlertDialog.Root {...wealthlaneAlert(modal)}>
 */
export function wealthlaneAlert(modal: NiceModalHandler) {
  return {
    open: modal.visible,
    onOpenChange: (open: boolean) => {
      if (!open) {
        modal.resolve({ confirmed: false });
        void modal.hide();
      }
    },
  };
}
